export function getAppStoreAppUrl(region: string) {
    return `https://apps.apple.com/${region.toLowerCase()}/app/equinet-mustad-farrier-app/id1459492568`;
}
